import { render } from "./ResetPasswordError.vue?vue&type=template&id=a9331a24&scoped=true"
import script from "./ResetPasswordError.vue?vue&type=script&lang=js"
export * from "./ResetPasswordError.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=a9331a24&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9331a24"]])

export default __exports__